import React from "react";
import { Button, SimpleForm, Toolbar } from "react-admin";

import { InitialData, PlanningConfig } from "./types";
import { planningConfigurations } from "./config/planningConfigurations";
import TestFcrRtePlanningItem from "./TestFcrRtePlanningItem";
import SendIcon from "@mui/icons-material/Send";
import { usePlanningSubmission } from "./hooks/usePlanningSubmission";

export interface PlanningFormProps {
  initialData: InitialData;
}

const TestFcrRtePlanningsForm: React.FC<PlanningFormProps> = ({ initialData }) => {
  const { defaultValues, handleSubmit, submitButtonProps } = usePlanningSubmission({ initialData });

  return (
    <SimpleForm
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      toolbar={
        <Toolbar>
          <Button
            variant="contained"
            size="large"
            label="Submit plannings"
            type="submit"
            startIcon={<SendIcon />}
            {...submitButtonProps}
          />
        </Toolbar>
      }
    >
      {planningConfigurations.map((config: PlanningConfig, index: number) => {
        return <TestFcrRtePlanningItem key={config.name} config={config} index={index} initialData={initialData} />;
      })}
    </SimpleForm>
  );
};
export default TestFcrRtePlanningsForm;
